<template>
  <div style="padding-bottom: 100px">
    <faq-editor
      :faq-uuid="faqUuid"
      :lite-slug="liteSlug"
    />

    <v-container>
      <div
        style="max-width: 420px;"
        class="mt-6 mx-auto"
      >
        <div class="mb-16 mt-4 elevation-8 rounded-lg px-4 py-4">
          <div class="text-center mb-0">
            <p class="text-subtitle-1">
              To use the FAQ on a page (as shown above)<br>use the shortcode
            </p>
            <code
              style="font-size: 20px; background: #F5F5F5"
            >[webcomet-faq]</code>
          </div>
        </div>

        <div class="elevation-8 rounded-lg px-4 py-4">
          <p class="text-subtitle-1 text-center">
            You can also show the FAQ as a widget that appears on all pages (as shown in the bottom right corner)
          </p>
          <v-switch
            v-model="widget_enabled"
            inset
            label="Enable FAQ widget"
          />

          <div class="text-center">
            <color-picker
              v-model="widget_primary_color"
              default-value="#d24919"
              label="Widget primary color"
              class="mb-8"
            />

            <v-text-field
              v-model="widget_toggle_label"
              outlined
              label="Text to show next to the widget icon"
              placeholder="This is your FAQ section used as a widget"
              style="max-width: 350px"
              class="mx-auto"
            />

            <v-btn
              color="primary"
              block
              :disabled="loading"
              :loading="loading"
              @click="saveChanges"
            >
              Save widget settings
            </v-btn>
          </div>
        </div>
      </div>
    </v-container>

    <portal to="widget">
      <webcomet-faq-widget
        :key="`widget-wp-${widgetKey}`"
        :faq-id="faqUuid"
        :disable-statistics="true"
        :toggle-label="state.widget_toggle_label || 'This is your FAQ section used as a widget'"
        :primary-color="state.widget_primary_color || '#D24919'"
      />
    </portal>
  </div>
</template>

<script>
import ColorPicker from '@/components/shared/ColorPicker';
import FaqEditor from '@/lite/components/FaqEditor';

export default {
  components: {
    FaqEditor,
    ColorPicker
  },

  props: {
    faqUuid: {
      type: String,
      required: true
    },
    liteSlug: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      widgetKey: 0,
      state: this.getInitialState(),
      loading: false,
      widget_enabled: null,
      widget_primary_color: '',
      widget_toggle_label: ''
    }
  },

  created() {
    const toBoolean = (val) => val === 'true' ? true : false;

    this.widget_enabled = toBoolean(this.state.widget_enabled);
    this.widget_primary_color = this.state.widget_primary_color;
    this.widget_toggle_label = this.state.widget_toggle_label;

    window.addEventListener('message', event => {
      if (event.data.name === 'saveWidgetSettingsResponse') {
        this.loading = false;
        if (event.data.success === true) {
          this.state.widget_primary_color = this.widget_primary_color;
          this.state.widget_toggle_label = this.widget_toggle_label;
          this.widgetKey++;
        } else {
          alert('Could not save widget settings');
        }
      }
    });

    window.eventBus.$on('widget:update', () => {
      this.widgetKey++;
    });
  },

  methods: {
    getInitialState() {
      const params = new URLSearchParams(window.location.search);
      return JSON.parse(window.atob(params.get('state')));
    },

    saveChanges() {
      this.loading = true;

      const payload = {
        widget_enabled: this.widget_enabled,
        widget_primary_color: this.widget_primary_color,
        widget_toggle_label: this.widget_toggle_label
      };

      const message = {
        name: 'saveWidgetSettings',
        value: payload
      };

      window.parent.postMessage(message, '*');
    }
  }
}
</script>

<style>
  .v-input--switch .v-input__control {
    flex-grow: 0 !important;
    width: auto !important;
    margin: 0 auto !important;
  }

  .menuable__content__active {
    z-index: 9999999999 !important;
  }
</style>